export enum TogglesConfiguration {
  CONSULT_SERASA = "consult-serasa",
  WORKING_CAPITAL = "working-capital",
  FILTERS_KANBAN = "filters kanban",
  AMPLIFIQUE_ME = "amplifique-me",
  CANCEL_PROPOSAL_KANBAN = "cancel-proposal-kanban",
  FAQ_ADMIN = "faq-admin",
  FAQ_MANAGER = "faq-manager",
  SELECT_API_AT_LOGIN = "select-api-at-login",
  MAIS_DIGITAL_PLAY = "mais-digital-play",
  SWITCH_LGPD_EXTERNAL = 'switch-lgpd-external'
}
